import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import { userType, common, errorFlag } from '@/app/model/store/domain/const'
import state from './app/model/store/domain/AccountState/state'
Vue.use(Router)

declare module 'vue-router/types/router' {
  interface VueRouter {
    go(n: number|{[key: string]: string|boolean}) : void
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // 共通
    {
      path: '/',
      redirect: 'field',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'ログイン',
      component: () => import('./views/Login.vue'),
      meta: {
        loginAuth: true,
        title: 'ログイン | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/password-reminder',
      name: 'パスワードリマインダー',
      component: () => import('./views/PasswordReminder.vue'),
      meta: {
        loginAuth: true,
        title: 'パスワードリマインダー | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/password-reminder/:uq_key',
      name: 'パスワード再設定',
      component: () => import('./views/PasswordResetting.vue'),
      meta: {
        loginAuth: true,
        title: 'パスワード再設定 | ' + common.SYSTEM_NAME
      }
    },
    // サービス画面
    {
      path: '/field',
      name: 'マップ・圃場一覧',
      component: () => import('./views/Field.vue'),
      meta: {
        requiresAuth: true,
        title: 'マップ・圃場一覧 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board',
      name: '栽培指導広報',
      component: () => import('./views/NewsBoard.vue'),
      meta: {
        requiresAuth: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/create',
      name: '栽培指導広報追加',
      component: () => import('./views/NewsBoardCreate.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        adminOnly: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/:news_board_id',
      name: '栽培指導広報詳細',
      component: () => import('./views/NewsBoardDetails.vue'),
      meta: {
        requiresAuth: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/:news_board_id/edit',
      name: '栽培指導広報編集・削除',
      component: () => import('./views/NewsBoardCreate.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        adminOnly: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/:news_board_id/content/create',
      name: '栽培指導広報記事追加',
      component: () => import('./views/NewsBoardContentCreate.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        adminOnly: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/:news_board_id/content/:news_board_content_id',
      name: '栽培指導広報記事編集・削除',
      component: () => import('./views/NewsBoardContentCreate.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        adminOnly: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/news-board/:news_board_id/content/:news_board_content_id/pdf-preview',
      name: '栽培指導広報PDFプレビュー',
      component: () => import('./views/NewsBoardPdfPreview.vue'),
      meta: {
        requiresAuth: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link',
      name: '外部連携',
      component: () => import('./views/ExternalLink.vue'),
      meta: {
        requiresAuth: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/create',
      name: '外部連携追加',
      component: () => import('./views/ExternalLinkCreate.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        adminOnly: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/:external_link_id',
      name: '外部連携詳細',
      component: () => import('./views/ExternalLinkDetails.vue'),
      meta: {
        requiresAuth: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/:external_link_id/edit',
      name: '外部連携編集・削除',
      component: () => import('./views/ExternalLinkCreate.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        adminOnly: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/:external_link_id/content/create',
      name: '外部連携連携追加',
      component: () => import('./views/ExternalLinkContentCreate.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        adminOnly: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/:external_link_id/content/:external_link_content_id',
      name: '外部連携連携編集・削除',
      component: () => import('./views/ExternalLinkContentCreate.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        adminOnly: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/external-link/:external_link_id/content/:external_link_content_id/pdf-preview',
      name: '外部連携PDFプレビュー',
      component: () => import('./views/ExternalLinkPdfPreview.vue'),
      meta: {
        requiresAuth: true,
        title: ' | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/cam-image',
      name: '圃場画像',
      component: () => import('./views/CamImage.vue'),
      meta: {
        requiresAuth: true,
        title: '圃場画像 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/field/order',
      name: '収穫指示',
      component: () => import('./views/FieldOrder.vue'),
      meta: {
        requiresAuth: true,
        title: '収穫指示 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/field/:field_id',
      name: '圃場詳細',
      component: () => import('./views/FieldDetails.vue'),
      meta: {
        requiresAuth: true,
        title: '圃場詳細 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/profit',
      name: '収益予実',
      component: () => import('./views/Profit.vue'),
      meta: {
        requiresAuth: true,
        title: '収益予実 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/mypage',
      name: 'マイページ',
      component: () => import('./views/MyPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'マイページ | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/error-page',
      name: 'エラーページ',
      component: () => import('./views/ErrorPage.vue'),
      meta: {
        errorFlag: true
      }
    },
    // マスタ画面
    {
      path: '/master',
      name: 'マスタ管理トップ',
      component: () => import('./views/Master.vue'),
      meta: {
        requiresAuth: true,
        title: 'マスタ管理トップ | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/user',
      name: 'ユーザー管理',
      component: () => import('./views/Account.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        title: 'ユーザー管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/user/create',
      name: 'ユーザー追加',
      component: () => import('./views/AccountCreate.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        title: 'ユーザー追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/user/:user_id',
      name: 'ユーザー編集・削除',
      component: () => import('./views/AccountEdit.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        title: 'ユーザー編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/group',
      name: 'グループ管理',
      component: () => import('./views/Group.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        title: 'グループ管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/group/create',
      name: 'グループ追加',
      component: () => import('./views/GroupCreate.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        title: 'グループ追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/group/:group_id',
      name: 'グループ編集・削除',
      component: () => import('./views/GroupEdit.vue'),
      meta: {
        requiresAuth: true,
        authorityFlag: true,
        title: 'グループ編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/area',
      name: '地域管理',
      component: () => import('./views/Area.vue'),
      meta: {
        requiresAuth: true,
        title: '地域管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/area/create',
      name: '地域追加',
      component: () => import('./views/AreaCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '地域追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/area/:area_id',
      name: '地域編集・削除',
      component: () => import('./views/AreaCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '地域編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/district',
      name: '地区管理',
      component: () => import('./views/District.vue'),
      meta: {
        requiresAuth: true,
        title: '地区管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/district/create',
      name: '地区追加',
      component: () => import('./views/DistrictCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '地区追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/district/:district_id',
      name: '地区編集・削除',
      component: () => import('./views/DistrictCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '地区編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/risk',
      name: '収穫リスク管理',
      component: () => import('./views/Risk.vue'),
      meta: {
        requiresAuth: true,
        title: '収穫リスク管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/risk/create',
      name: '収穫リスク追加',
      component: () => import('./views/RiskCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '収穫リスク追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/risk/:risk_id',
      name: '収穫リスク編集・削除',
      component: () => import('./views/RiskCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '収穫リスク編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety',
      name: '品種管理',
      component: () => import('./views/Variety.vue'),
      meta: {
        requiresAuth: true,
        title: '品種管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety/create',
      name: '品種追加',
      component: () => import('./views/VarietyCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '品種追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety/:variety_id',
      name: '品種編集・削除',
      component: () => import('./views/VarietyCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '品種編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety-growth',
      name: '品種生育管理',
      component: () => import('./views/VarietyGrowth.vue'),
      meta: {
        requiresAuth: true,
        title: '品種生育管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety-growth/create',
      name: '品種生育追加',
      component: () => import('./views/VarietyGrowthCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '品種生育追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/variety-growth/:variety_growth_id',
      name: '品種生育編集・削除',
      component: () => import('./views/VarietyGrowthCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '品種生育編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/machine',
      name: '機械管理',
      component: () => import('./views/Machine.vue'),
      meta: {
        requiresAuth: true,
        title: '機械管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/machine/create',
      name: '機械追加',
      component: () => import('./views/MachineCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '機械追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/machine/:machine_id/edit',
      name: '機械編集・削除',
      component: () => import('./views/MachineCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '機械編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/machine/:machine_id',
      name: '機械詳細',
      component: () => import('./views/MachineDetails.vue'),
      meta: {
        requiresAuth: true,
        title: '機械詳細 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/machine/:machine_id/maintenance/create',
      name: '機械メンテナンス追加',
      component: () => import('./views/MachineMaintenanceCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '機械メンテナンス追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/machine/:machine_id/maintenance/:maintenance_id',
      name: '機械メンテナンス編集・削除',
      component: () => import('./views/MachineMaintenanceCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '機械メンテナンス編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/machine-rent',
      name: '機械貸出管理',
      component: () => import('./views/MachineRent.vue'),
      meta: {
        requiresAuth: true,
        title: '機械貸出管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/machine-rent-status',
      name: '機械貸出状況',
      component: () => import('./views/MachineRentStatus.vue'),
      meta: {
        requiresAuth: true,
        title: '機械貸出状況 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/machine-rent/create',
      name: '機械貸出追加',
      component: () => import('./views/MachineRentCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '機械貸出追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/machine-rent/:machine_rent_id/edit',
      name: '機械貸出編集・削除',
      component: () => import('./views/MachineRentCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '機械貸出編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/machine-rent/:machine_rent_id',
      name: '機械貸出詳細',
      component: () => import('./views/MachineRentDetails.vue'),
      meta: {
        requiresAuth: true,
        title: '機械貸出詳細 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/plant',
      name: '作付け管理',
      component: () => import('./views/Plant.vue'),
      meta: {
        requiresAuth: true,
        title: '作付け管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/plant/create',
      name: '作付け追加',
      component: () => import('./views/PlantCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '作付け追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/plant/:plant_id',
      name: '作付け編集・削除',
      component: () => import('./views/PlantCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '作付け編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/field',
      name: '圃場管理',
      component: () => import('./views/MasterField.vue'),
      meta: {
        requiresAuth: true,
        title: '圃場管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/field/create',
      name: '圃場追加',
      component: () => import('./views/MasterFieldCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '圃場追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/field/:field_id',
      name: '圃場編集・削除',
      component: () => import('./views/MasterFieldCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '圃場編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/weed-alarm',
      name: '除草警報圃場一覧',
      component: () => import('./views/Weed.vue'),
      meta: {
        requiresAuth: true,
        title: '除草警報 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/ai-advice',
      name: 'AIアドバイス管理',
      component: () => import('./views/MasterAiAdvice.vue'),
      meta: {
        requiresAuth: true,
        title: 'AIアドバイス管理 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/ai-advice/create',
      name: 'AIアドバイス追加',
      component: () => import('./views/MasterAiAdviceCreate.vue'),
      meta: {
        requiresAuth: true,
        title: 'AIアドバイス追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/master/ai-advice/:ai_advice_id',
      name: 'AIアドバイス編集・削除',
      component: () => import('./views/MasterAiAdviceCreate.vue'),
      meta: {
        requiresAuth: true,
        title: 'AIアドバイス編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    // スマホ
    {
      path: '/sp',
      redirect: '/sp/field',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sp/login',
      name: 'ログイン',
      component: () => import('./views/SpLogin.vue'),
      meta: {
        loginAuth: true,
        title: 'ログイン | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/field',
      name: 'マップ・圃場一覧',
      component: () => import('./views/SpField.vue'),
      meta: {
        requiresAuth: true,
        title: 'マップ・圃場一覧 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/field/:field_id/:plant_id',
      name: '圃場・作付け詳細',
      component: () => import('./views/SpFieldDetails.vue'),
      meta: {
        requiresAuth: true,
        title: '圃場・作付け詳細 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/field/:field_id/:plant_id/record/create',
      name: '作付け生育記録追加',
      component: () => import('./views/SpFieldRecordCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '作付け生育記録追加 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/field/:field_id/:plant_id/record/:record_date',
      name: '作付け生育記録一覧',
      component: () => import('./views/SpFieldRecord.vue'),
      meta: {
        requiresAuth: true,
        title: '作付け生育記録一覧 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/field/:field_id/:plant_id/record/:record_date/edit',
      name: '作付け生育記録編集・削除',
      component: () => import('./views/SpFieldRecordCreate.vue'),
      meta: {
        requiresAuth: true,
        title: '作付け生育記録編集・削除 | ' + common.SYSTEM_NAME
      }
    },
    {
      path: '/sp/error-page',
      name: 'エラーページ',
      component: () => import('./views/SpErrorPage.vue'),
      meta: {}
    },
    {
      path: '/sp*',
      redirect: '/sp/field',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*',
      redirect: 'field',
      meta: {
        requiresAuth: true
      }
    }
  ]
})

/*
 * ログインしていないユーザー処理
*/
router.beforeEach((to, from, next) => {
  let user = Local.getAuthToken()
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  /* 認証不要ページはリクエストされたURLにそのままルーティング */
  if (!requiresAuth) {
    next()
    return
  }

  /* ローカルストレージにユーザー情報がない場合、ログイン画面にリダイレクト */
  if (!user) {
    if (to.path.indexOf('/sp') !== 0) {
      next({
        path: '/login'
      })
    } else {
      next({
        path: '/sp/login'
      })
    }
  } else {
    let device = ''
    if (to.path.indexOf('/sp') !== 0) {
      device = 'pc'
    } else {
      device = 'sp'
    }
    CommonClass.authCheck()
    CommonClass.consecutiveCheck()
    CommonClass.setServiceFunctionData(device)
    next()
  }
})

/*
 * ログインしているユーザーはログインページに飛ばさない
*/
router.beforeEach((to, from, loginNext) => {
  let user = Local.getAuthToken()
  let loginFlag = to.matched.some(record => record.meta.loginAuth)

  /* 認証不要ページはリクエストされたURLにそのままルーティング */
  if (!loginFlag) {
    loginNext()
    CommonClass.clearConstantValue(to.path)
    CommonClass.clearWeedAlarmCount()
    return
  }

  /* ログイン済みの場合はログイン画面へ飛ばさない */
  if (user) {
    if (to.path.indexOf('/sp') !== 0) {
      loginNext({
        path: '/field'
      })
    } else {
      loginNext({
        path: '/sp/field'
      })
    }
  } else {
    loginNext()
  }
})

router.beforeEach((to, from, manager) => {
  let user = Local.getAuthToken()
  let authority = parseInt(Local.getUserType()!)
  let authorityFlag = to.matched.some(record => record.meta.authorityFlag)

  /* 認証不要ページはリクエストされたURLにそのままルーティング */
  if (!authorityFlag) {
    manager()
    return
  }

  /* ローカルストレージにユーザー情報がない場合、403ページへ遷移 */
  if (!user) {
    manager({
      path: '/login'
    })
  } else {
    manager()
  }

  if (authority === userType.USER_TYPE_ADMIN) {
    authorityFlag = true
    manager()
  } else {
    // 権限のないユーザーは403ページを表示
    store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_AUTH)
    authorityFlag = false
    manager({
      path: '/error-page'
    })
  }
})

/*
 * エラー画面は直リンク遷移できない
 */
router.beforeEach((to, from, manager) => {
  let user = Local.getAuthToken()
  let flag = to.matched.some(record => record.meta.errorFlag)

  /* 認証不要ページはリクエストされたURLにそのままルーティング */
  if (!flag) {
    manager()
    return
  }

  let state: any = store.state
  if (state.routeState.errorFlag === 0) {
    flag = false
    manager({
      path: '/field'
    })
  } else {
    flag = true
    manager()
  }
})

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
